import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext, FieldArray } from 'formik';
import { memo } from 'react';
import CouplingsTable from './CouplingsTable';
const style = {
    borderSpacing: '0',
    width: '100%',
    fontSize: '12px',
    height: '100%',
    margin: '0',
    padding: '0.4rem',
    textAlign: 'center',
};
function SignalFormTab({ onFocus, onBlur }) {
    const { values } = useFormikContext();
    return (_jsx("div", { style: style, children: _jsx(FieldArray, { name: `signals.${values.activeTab}.js`, render: ({ push, remove }) => (_jsx("div", { children: _jsx(CouplingsTable, { push: push, remove: remove, onFocus: onFocus, onBlur: onBlur }) })) }) }));
}
export default memo(SignalFormTab);
